import React from "react";

export function ChatReviewIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 177.26 109.96"
      width="30"
      height="30"
      {...props}
    >
      <g>
        <path
          className="cls-2"
          d="m156.34,41.83h-71.27c-11.53,0-20.91-9.38-20.91-20.91S73.54,0,85.07,0h71.27c11.53,0,20.91,9.38,20.91,20.91s-9.38,20.91-20.91,20.91ZM85.07,5c-8.77,0-15.91,7.14-15.91,15.91s7.14,15.91,15.91,15.91h71.27c8.77,0,15.91-7.14,15.91-15.91s-7.14-15.91-15.91-15.91h-71.27Z"
        />
        <polygon
          className="cls-1"
          points="134.76 39.33 134.76 57.37 156.34 39.33 134.76 39.33"
        />
      </g>
      <g>
        <path
          className="cls-2"
          d="m92.18,94.11H20.91c-11.53,0-20.91-9.38-20.91-20.91s9.38-20.91,20.91-20.91h71.27c11.53,0,20.91,9.38,20.91,20.91s-9.38,20.91-20.91,20.91ZM20.91,57.28c-8.77,0-15.91,7.14-15.91,15.91s7.14,15.91,15.91,15.91h71.27c8.77,0,15.91-7.14,15.91-15.91s-7.14-15.91-15.91-15.91H20.91Z"
        />
        <polygon
          className="cls-1"
          points="42.86 91.61 42.86 109.96 20.91 91.61 42.86 91.61"
        />
      </g>
    </svg>
  );
}
